import React, { useEffect, useState } from "react";
import {
  useLocation,
  useOutletContext,
  useSearchParams,
} from "react-router-dom";
import "../../styles/admin/institutionCourseBatchInfo.scss";
import Student from "./student";
import Teacher from "./teacher";

const InstitutionCourseBatchInfo = () => {
  const [searchParams] = useSearchParams();
  const batchId = searchParams.get("batch_id");
  const institution_id = searchParams.get("institution");
  const location = useLocation();
  const tabs = [
    { key: "teacher", label: "Teachers" },
    { key: "students", label: "Students" },
  ];

  const [activeTab, setActiveTab] = useState(tabs[0].key);
  const { setHeaderName, setIsShowSearch } = useOutletContext() || {};
  const renderTabContent = () => {
    switch (activeTab) {
      case "students":
        return (
          <Student
            batchInfo={true}
            batchId={batchId}
            institution_id={institution_id}
          />
        );
      case "teacher":
        return (
          <Teacher
            batchInfo={true}
            batchId={batchId}
            institution_id={institution_id}
          />
        );

      default:
        return null;
    }
  };

  const title = location?.state?.batchName;
  useEffect(() => {
    setHeaderName(
      title?.charAt(0).toUpperCase() + title?.slice(1) || "Batch Information"
    );
    setIsShowSearch(false);
  }, []);

  return (
    <div className="institution-course-batch-info">
    

      <div className="tab-container">
        <div className="segmented-tabs" role="tablist" aria-label="Batch tabs">
          {tabs.map((tab) => (
            <button
              key={tab.key}
              type="button"
              role="tab"
              aria-selected={activeTab === tab.key}
              className={`segmented-tab ${
                activeTab === tab.key ? "active" : ""
              }`}
              onClick={() => setActiveTab(tab.key)}
            >
              {tab.label}
            </button>
          ))}
        </div>
      </div>

      <div className="tab-panel" role="tabpanel" aria-live="polite">
        {renderTabContent()}
      </div>
    </div>
  );
};

export default InstitutionCourseBatchInfo;
